/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AssignOONCustomerToVoiceCaseRequest} from '@cash-web/protos/squareup/cash/supportal/service.pb'
import {AssignOONCustomerToVoiceCaseResponse} from '@cash-web/protos/squareup/cash/supportal/service.pb'


export const assignOONCustomerToVoiceCase = (request: AssignOONCustomerToVoiceCaseRequest, options?: CashRequestOptions) => post<AssignOONCustomerToVoiceCaseRequest, AssignOONCustomerToVoiceCaseResponse>("/2.0/cash/assign-o-o-n-customer-to-voice-case", request, {...options, rejectOnError: true })